import { Component, inject, input, output } from '@angular/core';

import { TextToClipboardComponent } from '@camelot/core';
import { FontIconComponent } from '@camelot/icons';
import { LAZY_SERVICE_TOKEN } from '@camelot/notification';
import { Contact } from '@camelot/services';
import { TranslatePipe } from '@camelot/translation';
import { CardImageComponent, ItemProfileDisplayComponent } from '@camelot/ui';
import { CamBaseComponent, fullAddress, fullName } from '@camelot/utils';

import { CamTranslationProject } from '../../../../../translation.service';
import { ProjectExtended } from '../../../services/dto/project';
import { CamProjectStatusComponent } from '../../status/project-status.component';

@Component({
  selector: 'cam-project-profile',
  imports: [
    CardImageComponent,
    CamProjectStatusComponent,
    FontIconComponent,
    ItemProfileDisplayComponent,
    TextToClipboardComponent,
    TranslatePipe,
  ],
  templateUrl: './project-profile.component.html',
  styleUrl: './project-profile.component.scss',
})
export class ProjectProfileComponent extends CamBaseComponent {
  project = input.required<Partial<ProjectExtended>>();

  editable = input(false);

  edit = output<void>();

  protected _notificationService = inject(LAZY_SERVICE_TOKEN);
  public fullAddress = fullAddress;

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  public fullName(contact: Contact): string {
    return fullName({
      name: contact.lastName,
      firstName: contact.firstName,
    });
  }
}
